import { api } from './client.js';

/**
 * 노출메뉴관리(베스트) — 원본 zaiko/cate_best_list.php.
 * 계산은 서버(cateBest.service.ts)가 끝내서 내려준다.
 */
export type CateBestOrderBy = 'catename' | 'mcode' | 'soldout_score' | 'best_numper' | 'numper';

export interface CateBestRow {
  catename: string;
  mcode: string;
  soldoutScore: number;
  bestNumper: number;
  numper: number;
  isWarning: boolean;
}

export interface CateBestListParams {
  page: number;
  searchvalue: string;
  /** '' 이면 서버가 카테고리 코드순으로 준다 (원본 첫 화면) */
  orderby: CateBestOrderBy | '';
  order: 'ASC' | 'DESC';
}

export const cateBestApi = {
  list: (p: CateBestListParams) =>
    api.get<{ items: CateBestRow[]; updatedAt: string }>(
      `/reports/cate-best/list?${new URLSearchParams({
        page: String(p.page),
        searchvalue: p.searchvalue,
        orderby: p.orderby,
        order: p.order,
      }).toString()}`,
    ),
};
